export const couponView = (businessCode, couponCode) =>
  `/${businessCode.toLowerCase()}/vouchers/${couponCode}/`;

export const headwayBusinessScoreInfoView = () =>
  "https://headwayapp.co/the-guide-updates/complete-your-listing-to-improve-your-visibility!-210953";

const ACCOUNTS_BASE = "/accounts";
export const loginView = () => `${ACCOUNTS_BASE}/login/`;
